// src/pages/CyberwareCatalogue.js

import React from 'react';

const CyberwareCatalogue = () => {
  return (
    <div>
      <div className='main'>
        <div className="column1"></div>
        <div className="column2">
          <br />
          <br />
          <div style={{ textAlign: 'center' }}>
            <h1>Cyberware Catalogue</h1>
          </div>
            <p>
              The Cyberware catalogue is a community collaboration project to show the list of open source projects revolving around cyberware and cyborgs, as well as common, affordable chips, boards, and technologies to use, plus companies of interest in the space.
            </p>
            <p>
              This free service helps create a catalogue for organizations relating to biomedical engineering technologies, cyberware, and cyborgs. We do not endorse any company on this list; it serves to showcase open source community projects and notable companies in the cyberware and cyborg domains.
            </p>
            <p>
              If you have any suggestions to include or remove entries, please contact us at <a href="mailto:support@sabrenetics.com">support@sabrenetics.com</a>.
            </p>
            <p>
              Access the catalogue here: <a href="https://docs.google.com/spreadsheets/d/1KDIBAYLK2JfpX8fHJy2xSZs9JTyisOBdLzTTMFEY8y4" target="_blank" rel="noopener noreferrer">Google Spreadsheet</a>
            </p>
        </div>
        <div className="column3"></div>
      </div>
    </div>
  );
};

export default CyberwareCatalogue;
